import request from "../request";

export default {
  // 标签-列表
  list(data) {
    return request.get("/AdminLabel/list", data);
  },

  // 标签-添加
  add(data) {
    return request.post("/AdminLabel/create", data);
  },

  // 标签-编辑
  edit(data) {
    return request.post("/AdminLabel/edit", data);
  },

  // 标签-删除
  delete(data) {
    return request.post("/AdminLabel/delete", data);
  }
};
